import axios from "axios";
import * as R from 'ramda';

export const getNfts = async (walletAddress, isCustomWall) => {
  if (isCustomWall)
    await customWall(walletAddress);
  else await createWall();
  
  const nfts = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/addresses/${walletAddress}/nfts`
  );
  return nfts;
}
  

export const getNft = async (uri) => await axios.get(uri);

export const accessHome = async () => await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/analytics/home`);

export const createWall = async () => await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/analytics/create_wall`);

export const customWall = async (walletAddress) => await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/analytics/custom_wall_access/${walletAddress}`);
